





























































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import RouteNames from "@/router/RouteNames";
import { namespace } from "vuex-class";
import AppFooter from "@/components/common/AppFooter.vue";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component<LandingLayout>({
  components: { AppFooter },
  computed: {
    RouteNames() {
      return RouteNames;
    }
  },
  watch: {
    $route() {
      this.isMenuOpen = false;
    },
    isMenuOpen(val) {
      document.body.classList.toggle('overflow-hidden', val);
    }
  }
})
export default class LandingLayout extends Vue {
  @AppModule.State
  private isMobile!: boolean;

  @AppModule.State
  private windowWidth!: number;

  @Auth.Action
  private signOut!: () => void;

  private isMenuOpen = false;

  logOut() {
    this.signOut();
  }

  mounted() {
    document.documentElement.classList.add('landing-page-mode');
  }

  beforeDestroy() {
    document.documentElement.classList.remove('landing-page-mode');
  }

  get currentYear(): string {
    return moment().format("YYYY");
  }
}
